import { fetchAemContent } from "@/services/aem";
import { AEM_DATA_PATH } from "@/utils/constant";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const getReadyForYouData = createAsyncThunk(
  "/aem/getReadyForYouData",
  async () => {
    const res = await fetchAemContent(AEM_DATA_PATH.READY_FOR_YOU);
    return res;
  }
);
